var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', [_c('v-switch', _vm._b({
    staticClass: "ml-8",
    attrs: {
      "dense": ""
    },
    on: {
      "change": _vm.emit
    },
    model: {
      value: _vm.form.code.isOn,
      callback: function callback($$v) {
        _vm.$set(_vm.form.code, "isOn", $$v);
      },
      expression: "form.code.isOn"
    }
  }, 'v-switch', Object.assign({}, _vm.attrs_switch, {
    label: _vm.label
  }), false)), _c('v-expand-transition', [_c('v-sheet', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.form.code.isOn,
      expression: "form.code.isOn"
    }]
  }, [_c('v-text-field', _vm._b({
    staticClass: "mt-10",
    attrs: {
      "placeholder": "참여코드를 입력해주세요"
    },
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form.code.text,
      callback: function callback($$v) {
        _vm.$set(_vm.form.code, "text", $$v);
      },
      expression: "form.code.text"
    }
  }, 'v-text-field', _vm.attrs_input, false)), _c('p', {
    staticClass: "font-size-14 grey--text text--lighten-2 mt-4"
  }, [_vm._v("시청 시 참여코드를 입력해야 합니다.")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }